import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import * as moment_ from 'moment';
import { CommonModule } from '@angular/common';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { __awaiter, __generator, __values } from 'tslib';
import { Injectable, NgModule, defineInjectable, inject, EventEmitter, Component, Input, Output } from '@angular/core';
import { S2AHttpClient, NgCommonModule, Logger } from '@s2a/ng-common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UserService = /** @class */ (function () {
    function UserService(http) {
        var _this = this;
        this.http = http;
        this.listUsers = function (searchString) { return __awaiter(_this, void 0, void 0, function () {
            var options, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        options = {};
                        if (searchString) {
                            options.params = new HttpParams().set('searchString', searchString.toLowerCase());
                        }
                        return [4 /*yield*/, this.http.get('users', options).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(result)];
                }
            });
        }); };
        this.getUser = function (userId) { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get('users/' + userId).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(result)];
                }
            });
        }); };
        this.updateUser = function (user) { return __awaiter(_this, void 0, void 0, function () {
            var params, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            userId: user.userId,
                            login: user.login,
                            firstname: user.firstname,
                            lastname: user.lastname,
                            mail: user.mail,
                            isEnabled: user.isEnabled
                        };
                        if (user.phoneNumber && user.phoneNumber !== '') {
                            params['phoneNumber'] = user.phoneNumber;
                        }
                        return [4 /*yield*/, this.http.put('users', params).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(result)];
                }
            });
        }); };
        this.changePassword = function (oldPassword, newPassword) { return __awaiter(_this, void 0, void 0, function () {
            var params, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            oldPassword: oldPassword,
                            newPassword: newPassword
                        };
                        return [4 /*yield*/, this.http.put('users/me/changepassword', params).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(result)];
                }
            });
        }); };
        this.addUser = function (account, login, firstname, lastname, mail, phoneNumber, password) { return __awaiter(_this, void 0, void 0, function () {
            var params, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            account: account,
                            login: login,
                            firstname: firstname,
                            lastname: lastname,
                            mail: mail,
                            password: password
                        };
                        if (phoneNumber && phoneNumber !== '') {
                            params['phoneNumber'] = phoneNumber;
                        }
                        return [4 /*yield*/, this.http.post('users', params).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(result)];
                }
            });
        }); };
        this.setGlobalRoles = function (userId, roles) { return __awaiter(_this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.put('users/' + userId + '/global-roles', { roles: roles }).toPromise()];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, Promise.resolve(user)];
                }
            });
        }); };
        this.setObjectRoles = function (userId, roles) { return __awaiter(_this, void 0, void 0, function () {
            var user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.put('users/' + userId + '/object-roles', { roles: roles }).toPromise()];
                    case 1:
                        user = _a.sent();
                        return [2 /*return*/, Promise.resolve(user)];
                }
            });
        }); };
    }
    UserService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    UserService.ctorParameters = function () { return [
        { type: S2AHttpClient }
    ]; };
    /** @nocollapse */ UserService.ngInjectableDef = defineInjectable({ factory: function UserService_Factory() { return new UserService(inject(S2AHttpClient)); }, token: UserService, providedIn: "root" });
    return UserService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var moment = moment_;
/** @type {?} */
var logger = Logger('user');
/** @type {?} */
var ErrorUser = /** @type {?} */ ({
    userId: '-1',
    account: '',
    login: '',
    firstname: 'Unknown',
    lastname: 'User',
    mail: 'unknow@user',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    isEnabled: 1,
    roles: {
        global: [],
        object: [],
    },
});
var UserExtensions = /** @class */ (function () {
    function UserExtensions() {
    }
    /**
     * @param {?} user
     * @return {?}
     */
    UserExtensions.getUserLetters = /**
     * @param {?} user
     * @return {?}
     */
    function (user) {
        user = UserExtensions.handleError(user);
        return user.firstname.substr(0, 1).toUpperCase() +
            user.lastname.substr(0, 1).toUpperCase();
    };
    /**
     * @param {?} user
     * @return {?}
     */
    UserExtensions.getFullDisplayName = /**
     * @param {?} user
     * @return {?}
     */
    function (user) {
        user = UserExtensions.handleError(user);
        return "" + (user.firstname ? user.firstname + ' ' : '') + (user.lastname || '');
    };
    /**
     * @param {?} user
     * @return {?}
     */
    UserExtensions.getFormattedCreationAt = /**
     * @param {?} user
     * @return {?}
     */
    function (user) {
        user = UserExtensions.handleError(user);
        /** @type {?} */
        var createdAt = moment(user.createdAt);
        return createdAt.format('LLL');
    };
    /**
     * @param {?} user
     * @return {?}
     */
    UserExtensions.getFormattedUpdatedAt = /**
     * @param {?} user
     * @return {?}
     */
    function (user) {
        user = UserExtensions.handleError(user);
        /** @type {?} */
        var createdAt = moment(user.updatedAt);
        return createdAt.format('LLL');
    };
    /**
     * @param {?} user
     * @return {?}
     */
    UserExtensions.handleError = /**
     * @param {?} user
     * @return {?}
     */
    function (user) {
        if (!user) {
            return /** @type {?} */ (ErrorUser);
        }
        if (user['errorMessage']) {
            logger.error(user['errorMessage']);
            return /** @type {?} */ (ErrorUser);
        }
        return user;
    };
    return UserExtensions;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
var UserInfoType = {
    role: 'role',
    phoneNumber: 'phoneNumber',
};
var AddUserComponent = /** @class */ (function () {
    function AddUserComponent(modalRef, formBuilder, userService, translate) {
        var _this = this;
        this.modalRef = modalRef;
        this.formBuilder = formBuilder;
        this.userService = userService;
        this.translate = translate;
        this.searchControl = new FormControl();
        this.users = [];
        this.selectedUsers = [];
        this.preselectedUsers = [];
        this.isSingleUser = false;
        this.isLoading = false;
        this.usersOutput = new EventEmitter();
        this.loadUsers = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, index, removedUser;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.userService.listUsers(this.searchControl.value)];
                    case 1:
                        _a.users = _b.sent();
                        index = this.users.findIndex(function (u) { return u.userId === _this.localUser.userId; });
                        if (index !== -1) {
                            removedUser = this.users.splice(index, 1);
                            this.users.unshift(removedUser[0]);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        this.getUser = function () {
            return _this.localUser;
        };
        this.loadInitData = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        return [4 /*yield*/, this.loadUsers()];
                    case 1:
                        _a.sent();
                        this.copyElements();
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        }); };
        this.addUser = function (user) {
            if (!_this.isChecked(user)) {
                _this.selectedUsers.push(user);
                if (_this.isSingleUser) {
                    _this.save();
                }
            }
        };
        this.removeUser = function (user) {
            /** @type {?} */
            var index = _this.selectedUsers.findIndex(function (u) { return u.userId === user.userId; });
            _this.selectedUsers.splice(index, 1);
        };
        this.isChecked = function (user) {
            return _this.selectedUsers.findIndex(function (u) { return u.userId === user.userId; }) !== -1;
        };
        this.getUserLetters = function (user) {
            return UserExtensions.getUserLetters(user);
        };
        this.save = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.openedInModal) {
                    this.modalRef.hide();
                }
                this.usersOutput.emit(this.selectedUsers);
                this.onClose.next(this.selectedUsers); // for modal windows
                return [2 /*return*/];
            });
        }); };
        this.copyElements = function () {
            var e_1, _a;
            try {
                for (var _b = __values(_this.preselectedUsers), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var user = _c.value;
                    _this.selectedUsers.push(user);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        };
    }
    /**
     * @return {?}
     */
    AddUserComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.formGroup = this.formBuilder.group({
            searchString: this.searchControl
        });
        this.searchControlSubscription = this.searchControl.valueChanges
            .debounceTime(500)
            .subscribe(function (searchString) {
            _this.loadUsers();
        });
        this.loadInitData();
        this.onClose = new Subject();
    };
    /**
     * @return {?}
     */
    AddUserComponent.prototype.cancel = /**
     * @return {?}
     */
    function () {
        this.usersOutput.emit(this.preselectedUsers);
    };
    /**
     * @param {?} user
     * @return {?}
     */
    AddUserComponent.prototype.getUserInfo = /**
     * @param {?} user
     * @return {?}
     */
    function (user) {
        if (this.userInfoType === UserInfoType.role) {
            if (user.roles.global.length > 0) {
                return user.roles.global[0];
            }
        }
        else if (this.userInfoType === UserInfoType.phoneNumber) {
            return user.phoneNumber;
        }
    };
    /**
     * @param {?} user
     * @return {?}
     */
    AddUserComponent.prototype.addUserDisabled = /**
     * @param {?} user
     * @return {?}
     */
    function (user) {
        if (this.disableNotFilledAccordingType) {
            if (this.userInfoType === UserInfoType.phoneNumber && user.phoneNumber === undefined) {
                return true;
            }
        }
        return false;
    };
    AddUserComponent.decorators = [
        { type: Component, args: [{
                    selector: 's2a-add-user',
                    template: "<div class=\"user-selection\">\n<ng-container *ngIf=\"openedInModal\">\n  <s2a-modal-header class=\"no-headline\" title=\"{{ 'components.maintenance.add_user.title' | translate }}\" [modalRef]=\"modalRef\"></s2a-modal-header>\n</ng-container>\n\n<div class=\"modal-body\">\n  <ng-container *ngIf=\"isLoading\">\n    <s2a-spinner></s2a-spinner>\n  </ng-container>\n  <ng-container *ngIf=\"!isLoading\">\n    <form [formGroup]=\"formGroup\">\n      <div class=\"grid-wrapper\">\n        <div class=\"top-bar\">\n          <!-- SEARCH BAR -->\n          <div [formGroup]=\"formGroup\" class=\"search-bar\">\n            <input type=\"text\" class=\"form-control\" formControlName=\"searchString\" placeholder=\"{{ 'global.search' | translate }}\" />\n          </div>\n        </div>\n        <div class=\"scroll-content\" [ngClass]=\"{\n          'scroll-content-modal': openedInModal\n        }\">\n          <!-- Pinned parts -->\n          <ul class=\"user-list list-unstyled\">\n            <li *ngFor=\"let user of selectedUsers\" (click)=\"removeUser(user)\">\n              <div class=\"leaf-card active\">\n                <div class=\"user-wrapper\">\n                  <!-- <div class=\"user-img\">\n                    <img src=\"http://via.placeholder.com/50x50\" alt=\"\">\n                  </div> -->\n                  <div class=\"user-img\">\n                    <span class=\"text-placeholder\">\n                      {{ getUserLetters(user) }}\n                    </span>\n                  </div>\n                  <div class=\"user-info\">\n                    <div class=\"user-name\">{{user.firstname}} {{user.lastname}}</div>\n                    <ng-container *ngIf=\"getUserInfo(user) !== null\">\n                      <small class=\"user-account\">{{getUserInfo(user)}}</small>\n                    </ng-container>\n                  </div>\n                </div>\n                <div class=\"checkbox-wrapper\">\n                  <div class=\"checkbox\">\n                    <input [id]='user.userId' type='checkbox' [checked]=\"isChecked(user)\" (change)=\"removeUser(user)\" />\n                    <label [for]='user.userId'>\n                      <span></span>\n                    </label>\n                  </div>\n                </div>\n              </div>\n            </li>\n          </ul>\n          <div *ngIf=\"!openedInModal\" class=\"float-right\">\n            <ng-container *ngIf=\"!isSingleUser\">\n              <button class=\"btn btn-primary btn-leaf btnSave\" type=\"Submit\" translate (click)=\"save()\">components.global.add_user.add</button>\n            </ng-container>\n            <button class=\"btn btn-primary btn-leaf btnDelete\" type=\"Cancel\" translate (click)=\"cancel()\">components.global.add_user.cancel</button>\n          </div>\n          <hr>\n          <!-- Search Results -->\n          <ul class=\"user-list list-unstyled\">\n            <ng-container *ngFor=\"let user of users\">\n              <li *ngIf=\"!isChecked(user)\" (click)=\"addUserDisabled(user) || addUser(user)\">\n                <div class=\"leaf-card\"  [ngClass]=\"{'disabled-user': addUserDisabled(user)}\">\n                  <div class=\"user-wrapper\">\n                    <!-- <div class=\"user-img\">\n                      <img src=\"http://via.placeholder.com/50x50\" alt=\"\">\n                    </div> -->\n                    <div class=\"user-img\">\n                      <span class=\"text-placeholder\">\n                        {{ getUserLetters(user) }}\n                      </span>\n                    </div>\n                    <div class=\"user-info\">\n                      <div class=\"user-name\">{{user.firstname}} {{user.lastname}}</div>\n                      <ng-container *ngIf=\"getUserInfo(user) !== null\">\n                        <small class=\"user-account\">{{getUserInfo(user)}}</small>\n                      </ng-container>\n                    </div>\n                  </div>\n                  <div class=\"checkbox-wrapper\">\n                    <div class=\"checkbox\">\n                      <input *ngIf=\"!addUserDisabled(user)\" [id]='user.userId' type='checkbox' [checked]=\"isChecked(user)\" (change)=\"addUser(user)\" />\n                      <label [for]='user.userId'>\n                        <span></span>\n                      </label>\n                    </div>\n                  </div>\n                </div>\n              </li>\n            </ng-container>\n          </ul>\n          <!-- No matching user -->\n          <ng-container *ngIf=\"users.length === 0\">\n            <div class=\"row\">\n              <div class=\"col-12 text-center\">\n                <span translate>components.maintenance.add_user.no_matching_user</span>\n              </div>\n            </div>\n          </ng-container>\n        </div>\n      </div>\n    </form>\n  </ng-container>\n</div>\n\n<div class=\"modal-footer\" *ngIf=\"openedInModal && !isSingleUser\">\n  <button class=\"btn btn-primary btn-leaf float-right\" type=\"Submit\" translate (click)=\"save()\">components.global.add_user.add</button>\n</div>\n</div>\n",
                    styles: [":host .modal-body{overflow:hidden}:host .modal-body .grid-wrapper{display:flex;flex-direction:column;max-height:calc(100vh - 300px)}:host .modal-body .grid-wrapper .top-bar{flex:0 0 auto;padding:15px 0;border-bottom:1px solid}.theme-light :host .modal-body .grid-wrapper .top-bar{border-color:#e0e0e0}.theme-dark :host .modal-body .grid-wrapper .top-bar{border-color:#405b7c}:host .modal-body .grid-wrapper .scroll-content-modal{overflow-y:auto;overflow-x:hidden}:host .modal-body .grid-wrapper .scroll-content{flex:1 1 auto;position:relative;-webkit-overflow-scrolling:touch}:host .modal-body .grid-wrapper .scroll-content .user-list{margin-bottom:0}:host .modal-body .grid-wrapper .scroll-content .user-list li{display:inline-block;width:100%;margin:4px 0}:host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card{border-radius:0 15px;display:flex;flex-direction:row;width:100%;padding-bottom:5px;transition:.3s linear}.theme-light :host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card{border:1px solid #d8d8d8}.theme-dark :host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card{border:1px solid #fff}@media print{.theme-dark :host .modal-body .grid-wrapper .top-bar{border-color:#e0e0e0}.theme-dark :host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card{border:1px solid #d8d8d8}}@media (min-width:992px){:host .modal-body .grid-wrapper .scroll-content .user-list li{display:inline-flex;width:50%}:host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card{margin-right:10px}}:host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card h5{margin-bottom:0}:host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card .user-wrapper{flex:1 1 auto}:host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card .user-wrapper .user-img{margin-left:10px;display:inline-block;border-radius:0 15px;width:42px;height:42px;overflow:hidden;border:2px solid;margin-top:12px}.theme-light :host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card .user-wrapper .user-img{border-color:#d8d8d8}.theme-dark :host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card .user-wrapper .user-img{border-color:#fff}:host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card .user-wrapper .user-img .text-placeholder{font-weight:700;display:block;width:38px;height:38px;line-height:38px;text-align:center}.theme-light :host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card .user-wrapper .user-img .text-placeholder{background-color:#f7f7f7;color:#525252}.theme-dark :host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card .user-wrapper .user-img .text-placeholder{background-color:#193a61;color:#fff}:host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card .user-wrapper .user-img img{width:100%}:host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card .user-wrapper .user-info{display:inline-block;margin-left:10px;margin-right:10px;margin-top:14px;vertical-align:top}.theme-light :host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card .user-wrapper .user-info{color:#525252}.theme-dark :host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card .user-wrapper .user-info{color:#fff}@media (min-width:768px){:host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card .user-wrapper .user-info{margin-right:25px}}:host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card .user-wrapper .user-info .user-name{font-size:14px;font-weight:700;max-width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card .user-wrapper .user-info .user-account{font-size:14px;max-width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}:host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card .checkbox-wrapper{padding:10px;flex:0 0 auto}:host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card:hover{cursor:pointer}.theme-light :host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card:hover{border-color:#3382c2}.theme-dark :host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card:hover{border-color:#fff}@media print{.theme-dark :host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card .user-wrapper .user-img{border-color:#d8d8d8}.theme-dark :host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card .user-wrapper .user-img .text-placeholder{background-color:#f7f7f7;color:#525252}.theme-dark :host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card .user-wrapper .user-info{color:#525252}.theme-dark :host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card:hover{border-color:#3382c2}}.theme-light :host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card.active{border-color:#3382c2}.theme-dark :host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card.active{border-color:#fff}@media print{.theme-dark :host .modal-body .grid-wrapper .scroll-content .user-list li .leaf-card.active{border-color:#3382c2}}:host.addUser .user-selection .no-headline{display:none!important}:host.addUser .user-selection .modal-body{max-height:calc(100vh - 365px);height:calc(100vh - 365px);overflow-y:auto!important;padding-top:0!important}:host.addUser .user-selection .modal-body .grid-wrapper{width:710px}:host.addUser .user-selection .modal-body .grid-wrapper .top-bar{border:0;padding:0 0 2rem}:host.addUser .user-selection .modal-body .grid-wrapper .top-bar .search-bar input[type=text].form-control{padding:.25rem!important;font-size:1.125rem;font-weight:400;font-style:italic;text-indent:.75rem;border:0;border-radius:0;height:37px;border-bottom:2px solid;background-color:transparent!important}.theme-light :host.addUser .user-selection .modal-body .grid-wrapper .top-bar .search-bar input[type=text].form-control{color:#525252!important;background-color:#e9e9e9;border-color:#d8d8d8!important}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .top-bar .search-bar input[type=text].form-control{color:#fff!important;background-color:#2b4671;border-color:#fff!important}:host.addUser .user-selection .modal-body .grid-wrapper .top-bar .search-bar input[type=text].form-control:focus{box-shadow:0 0 0 0 transparent}.theme-light :host.addUser .user-selection .modal-body .grid-wrapper .top-bar .search-bar input[type=text].form-control::-webkit-input-placeholder{color:#525252!important}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .top-bar .search-bar input[type=text].form-control::-webkit-input-placeholder{color:#fff!important}@media print{.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .top-bar .search-bar input[type=text].form-control{color:#525252!important;background-color:#e9e9e9}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .top-bar .search-bar input[type=text].form-control::-webkit-input-placeholder{color:#525252!important}}.theme-light :host.addUser .user-selection .modal-body .grid-wrapper .top-bar .search-bar input[type=text].form-control::-moz-placeholder{color:#525252!important}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .top-bar .search-bar input[type=text].form-control::-moz-placeholder{color:#fff!important}@media print{.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .top-bar .search-bar input[type=text].form-control::-moz-placeholder{color:#525252!important}}.theme-light :host.addUser .user-selection .modal-body .grid-wrapper .top-bar .search-bar input[type=text].form-control:-ms-input-placeholder{color:#525252!important}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .top-bar .search-bar input[type=text].form-control:-ms-input-placeholder{color:#fff!important}:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .float-right{margin:1rem 0}:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .float-right button.btn{background:linear-gradient(-135deg,#50bee4 0,#2874ba 100%)!important;border:2px solid!important;width:8.25rem;height:2.313rem;font-size:.875rem;font-weight:400;text-transform:lowercase;line-height:1;box-shadow:0 0 0 0 transparent;transition:.3s linear}.theme-light :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .float-right button.btn{border-color:#fff!important;color:#fff!important}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .float-right button.btn{border-color:#fff!important;color:#fff!important}:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .float-right button.btn.btn-leaf.disabled,:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .float-right button.btn.btn-leaf:disabled{opacity:1}.theme-light :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .float-right button.btn.btn-leaf.disabled,.theme-light :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .float-right button.btn.btn-leaf:disabled{background:#d8d8d8!important}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .float-right button.btn.btn-leaf.disabled,.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .float-right button.btn.btn-leaf:disabled{background:#d8d8d8!important}:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .float-right button.btn.btnSave{margin-right:.75rem!important}:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content hr{margin-top:4.5rem}:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list{display:flex;margin-bottom:0;flex-direction:row;flex-wrap:wrap;justify-content:space-between}:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list li{width:49%}:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card{height:75px;padding:0!important;margin-right:0!important;border:2px solid}.theme-light :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card{border-color:#d8d8d8}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card{border-color:#fff}.theme-light :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card.active{border-color:#3382c2}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card.active{border-color:#fff}:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card.disabled-user{opacity:.35;cursor:inherit}:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .user-wrapper{padding:.25rem}.theme-light :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .user-wrapper .user-info{color:#525252!important}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .user-wrapper .user-info{color:#fff!important}@media print{.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .top-bar .search-bar input[type=text].form-control:-ms-input-placeholder{color:#525252!important}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .top-bar .search-bar input[type=text].form-control{border-color:#d8d8d8!important}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .float-right button.btn{border-color:#fff!important;color:#fff!important}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .float-right button.btn.btn-leaf.disabled,.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .float-right button.btn.btn-leaf:disabled{background:#d8d8d8!important}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card{border-color:#d8d8d8}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card.active{border-color:#3382c2}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .user-wrapper .user-info{color:#525252!important}}:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper{padding:25px 10px}:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent!important;position:relative;border:2px solid;width:18px;height:18px;cursor:pointer;display:block}.theme-light :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]{border-color:#525252!important}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]{border-color:#fff!important}:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]:before{content:\"\";position:absolute;width:0;height:3px;left:5px;top:6.5px;-webkit-transform:rotate(50deg);transform:rotate(50deg);-webkit-transform-origin:0 0;transform-origin:0 0;transition:width 50ms 50ms}.theme-light :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]:before{background-color:#fff!important}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]:before{background-color:#fff!important}:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]:after{content:\"\";position:absolute;width:0;height:3px;top:11.5px;left:5px;-webkit-transform:rotate(320deg);transform:rotate(320deg);-webkit-transform-origin:0 0;transform-origin:0 0;transition:width 50ms}.theme-light :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]:after{background-color:#fff!important}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]:after{background-color:#fff!important}@media print{.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]{border-color:#525252!important}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]:before{background-color:#fff!important}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]:after{background-color:#fff!important}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]:checked,.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]:hover{background-color:#3382c2!important}}:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]:focus{outline:0;box-shadow:0 0 0 0 transparent}:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]:checked,:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]:hover{border:0}.theme-light :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]:checked,.theme-light :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]:hover{background-color:#3382c2!important}.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]:checked,.theme-dark :host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]:hover{background-color:#3382c2!important}:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]:checked:before,:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]:hover:before{width:6px;transition:width .1s}:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]:checked:after,:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper input[type=checkbox]:hover:after{width:12px;transition:width 150ms .1s}:host.addUser .user-selection .modal-body .grid-wrapper .scroll-content .user-list .leaf-card .checkbox-wrapper label{display:none}"]
                }] }
    ];
    /** @nocollapse */
    AddUserComponent.ctorParameters = function () { return [
        { type: BsModalRef },
        { type: FormBuilder },
        { type: UserService },
        { type: TranslateService }
    ]; };
    AddUserComponent.propDecorators = {
        localUser: [{ type: Input }],
        preselectedUsers: [{ type: Input }],
        userInfoType: [{ type: Input }],
        openedInModal: [{ type: Input }],
        disableNotFilledAccordingType: [{ type: Input }],
        isSingleUser: [{ type: Input }],
        usersOutput: [{ type: Output }]
    };
    return AddUserComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var NgUsersModule = /** @class */ (function () {
    function NgUsersModule() {
    }
    NgUsersModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        NgCommonModule,
                        CommonModule,
                        TranslateModule,
                        FormsModule,
                        ReactiveFormsModule
                    ],
                    declarations: [
                        AddUserComponent
                    ],
                    exports: [
                        AddUserComponent
                    ],
                    entryComponents: [
                        AddUserComponent
                    ]
                },] }
    ];
    return NgUsersModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var AccountService = /** @class */ (function () {
    function AccountService(http) {
        var _this = this;
        this.http = http;
        this.getAccountRoles = function (accountId) { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get('account/' + accountId + '/roles').toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(result)];
                }
            });
        }); };
    }
    AccountService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    AccountService.ctorParameters = function () { return [
        { type: S2AHttpClient }
    ]; };
    /** @nocollapse */ AccountService.ngInjectableDef = defineInjectable({ factory: function AccountService_Factory() { return new AccountService(inject(S2AHttpClient)); }, token: AccountService, providedIn: "root" });
    return AccountService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var maintenanceManagerUserObjectRole = {
    'objectId': '698eed94-39af-4f0d-b7e4-e6fc9e59346d',
    'role': 'maintenance-manager'
};
/** @type {?} */
var maintenanceUserObjectRole = {
    'objectId': '698eed94-39af-4f0d-b7e4-e6fc9e59346d',
    'role': 'maintenance'
};
/** @type {?} */
var objectRoles = [
    maintenanceManagerUserObjectRole,
    maintenanceUserObjectRole
];
/** @type {?} */
var globalUserRoles = [
    'admin',
    'maintenance',
    'maintenance-manager'
];
/** @type {?} */
var user1 = {
    'phoneNumber': '+49112345679',
    'lastname': 'User1Lastname',
    'login': 'User1FirstName.User1Lastname',
    'roles': { 'global': globalUserRoles, 'object': objectRoles },
    'userId': '49edab98-ag64-9999-bad5-26b0751c886',
    'firstname': 'User1FirstName',
    'account': 'watchdog-it',
    'mail': 'User1FirstName.User1Lastname@syskron.com',
    'isEnabled': 1
};
/** @type {?} */
var user2 = {
    'phoneNumber': '+49112345679',
    'lastname': 'User2Lastname',
    'login': 'User2FirstName.User2Lastname',
    'roles': { 'global': globalUserRoles, 'object': objectRoles },
    'userId': '55edab55-ag64-9999-bad5-26b0751c886',
    'firstname': 'User2FirstName',
    'account': 'watchdog-it',
    'mail': 'User2FirstName.User2Lastname@syskron.com',
    'isEnabled': 1
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { NgUsersModule, ErrorUser, UserExtensions, UserService, AccountService, UserInfoType, AddUserComponent, maintenanceManagerUserObjectRole, maintenanceUserObjectRole, objectRoles, globalUserRoles, user1, user2 };

//# sourceMappingURL=s2a-ng-users.js.map